<template>
  <div class="contact-detail-email">
    <div class="d-flex align-center justify-space-between mb-2">
      <h4 class="text-subtitle-1 d-flex align-center">
        <v-icon start color="blue">mdi-email</v-icon>
        E-mail adres
      </h4>
      <v-btn
        icon
        variant="text"
        size="small"
        :color="disabled ? 'success' : 'error'"
        :title="
          disabled ? 'E-mail adres herstellen' : 'E-mail adres verwijderen'
        "
        @click="$emit('remove')"
      >
        <v-icon>{{ disabled ? "mdi-undo" : "mdi-delete" }}</v-icon>
      </v-btn>
    </div>

    <v-text-field
      :model-value="modelValue.email"
      label="E-mail adres"
      placeholder="bijvoorbeeld@email.com"
      variant="outlined"
      density="comfortable"
      :rules="[rules.required, rules.email]"
      prepend-inner-icon="mdi-email"
      class="mb-3"
      type="email"
      :disabled="disabled"
      @update:model-value="updateEmail"
    />

    <div v-if="showPrimary" class="d-flex align-center">
      <v-switch
        :model-value="modelValue.primary"
        label="Primair e-mail adres"
        color="primary"
        hide-details
        :disabled="disabled"
        @update:model-value="updatePrimary"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  showPrimary: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "remove"]);

const rules = {
  required: (value) => !!value || "E-mail adres is verplicht",
  email: (value) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(value) || "Voer een geldig e-mailadres in";
  },
};

const updateEmail = (value) => {
  emit("update:modelValue", {
    ...props.modelValue,
    email: value,
  });
};

const updatePrimary = (value) => {
  emit("update:modelValue", {
    ...props.modelValue,
    primary: value,
  });
};
</script>

<style scoped>
.contact-detail-email {
  border-left: 3px solid rgb(var(--v-theme-blue));
  padding-left: 16px;
}
</style>
